import { Alert } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FrontendRoutes from 'assets/js/classes/FrontendRoutes';

export default function SmsBalanceAlert({ balance, showSmsBalanceAlert }) {
  return (
    <Alert 
      className="mb-3 d-flex align-items-center text-break"
      show={showSmsBalanceAlert} 
      variant="warning" 
    >
      <FontAwesomeIcon icon={['far', 'wallet']} fixedWidth size="2x" />
      <div className="ml-4">
        <p>Low Balance!</p>

        <p 
          className="m-0" 
          style={{ whiteSpace: 'break-spaces' }}
        >
          Your current balance is &euro;{(balance * -1 / 100).toFixed(2)}.
        </p>

        <a target="_blank" href={FrontendRoutes.SMS_TOPUP}>
          Top up
          <FontAwesomeIcon 
            icon={['far', 'arrow-up-right-from-square']} 
            fixedWidth 
            size="sm" 
            className="ml-1" 
          />
        </a>
      </div>
    </Alert>
  );
};